import styled from "styled-components";

export const StyledCartBtn = styled.section``;
